import { useMarketAnalysisSectionContent } from './useMarketAnalysisSectionContent';
import { parseMarketAnalysisPostsSettingsContent } from '../utils/marketAnalysisContent';

export const useMarketAnalysisPostsSettingsContent = () =>
  useMarketAnalysisSectionContent(parseMarketAnalysisPostsSettingsContent);
